import React, { useEffect, useState } from 'react'
// import { capitalizeString } from '../utils/helpers'
import { AiOutlineSearch } from 'react-icons/ai'
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';


type NewSearchProps = {
  searchType: string
  searchTerm: string
  // {search:string, filter: string}
  filterSetting: boolean
  toggleFilterSetting: () => void
  changeSearchTerm: React.Dispatch<React.SetStateAction<string>>
  // React.Dispatch<React.SetStateAction<{search: string, filter: string}>>
}

const NewSearch: React.FC<NewSearchProps> = ({searchType, searchTerm, filterSetting, changeSearchTerm, toggleFilterSetting}) => {

  // var { allCommunities, isLoadingCommunities } = useSearchCommunities(searchTerm)
  // console.log("allCommunities", allCommunities)
  const [width, setWidth] = useState(window.innerWidth);

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }
  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  const isMobile = width < 1440;
  

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    var { name, value } = e.target
    if ((value === "" || value) && name === searchType){
      changeSearchTerm(value)
    }
  }

  let searchFor = searchType
  if (searchType === "kitchens"){
    searchFor = "kitchens"
  } else if (searchType === "reservations"){
    searchFor = "reservations"
  } else if (searchType === "resources"){
    searchFor = "culinary resources"
  }else if (searchType === "messages"){
    searchFor = "messages"
  }



  return (
    <div className={`flex flex-row items-center    ${isMobile? "w-full":"w-[782px]"} `}>
      <div className='flex flex-row w-full flex-start h-auto md:max-h-10 '>
        <div className='bg-primaryLight-1000 rounded-xl flex items-center px-2 w-full shadow-none md:shadow-slate-300-inner md:shadow-sm border border-gray-200/50'>
            <AiOutlineSearch size={isMobile? 30: 20} className='text-grayDark-300'/>
            <input className='bg-transparent text-sm outline-grayDark-100 text-text-300 focus:outline-none w-full mx-auto border-0 rounded-xl' type='text' name={searchType} placeholder={`Search for ${searchFor}`} value={searchTerm} onChange={e => handleOnChange(e)} />
            {/* {isLoadingCommunities ? "...searching" : ""} */}

            {/* <FilterAltOutlinedIcon className='text-white/70 rounded-full bg-gray-400 m-auto' /> */}
        </div>
        {
          (searchType === "messages") ? <></> :
          (<div 
              className={`${["resources", "inventory"].includes(searchType)  ? 'invisible': ''} ${(filterSetting) ? 'hover:bg-primaryDark-400/70 bg-primaryDark-400 text-gray-200/80 hover:text-gray-500/70' : 'bg-white hover:bg-primaryDark-400 hover:text-white text-gray-500/70 '} cursor-pointer rounded-full  m-auto p-1 flex items-center justify-center border-0 md:border-[1px]`}
            >
              <FilterAltOutlinedIcon className='m-auto' onClick={toggleFilterSetting} />
          </div>)
        }
      </div>
    </div>
  )
}

export default NewSearch